import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
export function Closing() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-white py-24 px-6 text-center" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <FadeIn data-id="element-47">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-green mb-4" data-id="element-48">
            No necesitas saberlo todo…
          </h2>
          <p className="text-2xl md:text-3xl font-serif text-brand-green/80 mb-12" data-id="element-49">
            Pero sí puedes empezar mejor que ayer.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-6 sm:gap-12 mb-12 text-lg font-medium text-brand-text" data-id="element-50">
            <p className="flex items-center justify-center gap-2" data-id="element-51">
              <span data-id="element-52">👉</span> Con claridad
            </p>
            <p className="flex items-center justify-center gap-2" data-id="element-53">
              <span data-id="element-54">👉</span> Con dirección
            </p>
            <p className="flex items-center justify-center gap-2" data-id="element-55">
              <span data-id="element-56">👉</span> Con una guía real
            </p>
          </div>

          <Button onClick={scrollToPricing} className="text-lg px-12 py-5" data-id="element-57">
            EMPEZAR DESDE CASA AHORA
          </Button>
        </FadeIn>
      </div>
    </section>;
}